import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  highContrast: boolean
  reducedMotion: boolean
  toggleHighContrast: () => void
  setReducedMotion: (v: boolean) => void
  apply: () => void
}

/** Accessibility preferences (WCAG 2.2 AA). Dark mode is always enforced. */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      highContrast: false,
      reducedMotion: false,
      toggleHighContrast: () => {
        set((s) => ({ highContrast: !s.highContrast }))
        get().apply()
      },
      setReducedMotion: (v) => {
        set({ reducedMotion: v })
        get().apply()
      },
      apply: () => {
        const { highContrast, reducedMotion } = get()
        const el = document.documentElement
        el.dataset.contrast = highContrast ? 'high' : 'normal'
        el.dataset.motion = reducedMotion ? 'reduced' : 'normal'
      },
    }),
    { name: 'grymwyrd-theme' },
  ),
)
